<template>
  <div class="announcement-list pb-4 mb-6" data-testid="announcement-list">
    <div class="announcement-list-header">
      <v-icon class="mr-2">campaign</v-icon>
      <span class="font-weight-bold">{{ $t('title') }}</span>
    </div>
    <div class="announcement-list-items pl-5 pt-2">
      <div
        v-for="item in announcements"
        :key="item.url"
        class="announcement-list-item"
        data-testid="announcement-item"
      >
        <span class="pr-2">・</span>
        <a v-if="item.url" :href="item.url" target="_blank" rel="noopener noreferrer">
          {{ item.title }}
        </a>
        <span v-else>{{ item.title }}</span>
        <span v-if="isNew(item.date)" class="announcement-list-item-new ml-2" data-testid="new-badge">NEW</span>
        <span
          class="announcement-list-item-date ml-2"
          data-testid="announcement-date"
        >{{ formatDate(item.date) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { isAfter, parse, subDays } from 'date-fns';

import DateTimeFormatting from '@/mixins/dateTimeFormatting';

const NEW_BADGE_THRESHOLD_DAYS = 30;

export default {
  name: 'announcement-list',
  mixins: [DateTimeFormatting],
  props: {
    announcements: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    isNew(date) {
      if (!date) return false;
      const threshold = subDays(new Date(), NEW_BADGE_THRESHOLD_DAYS);
      return isAfter(parse(date, 'yyyy-MM-dd', new Date()), threshold);
    },
  },
};
</script>

<i18n lang="yaml">
ja:
  title: 新着ニュース
en:
  title: News (For now, only available in Japanese)
</i18n>

<style lang="sass" scoped>
.announcement-list
  &-header
    display: flex
    align-items: center
    padding: 8px 0
    border-bottom: 1px solid #e0e0e0

  &-item
    padding: 4px 0

    &-new
      color: #ff5252
      font-weight: bold
      font-size: 0.8em

    &-date
      color: #757575
      font-size: 0.9em
</style>
